import axios, { type AxiosResponse } from 'axios';
import type { ReviewSummary } from '../model/types';
import { getAdaptedReviewSummary } from './getReviewSummary.adapter';
import { type GetReviewSummaryApiResponse } from './getReviewSummary.types';

const REVIEW_SUMMARY_URL = '/hotel/review-summary';

export const getReviewSummary = async (hotelId: number): Promise<ReviewSummary | null> => {
  const { data }: AxiosResponse<GetReviewSummaryApiResponse> = await axios({
    url: REVIEW_SUMMARY_URL,
    method: 'GET',
    params: { hotelId },
  });

  if (!data.success) {
    throw new Error('Failed to fetch review summary');
  }

  return getAdaptedReviewSummary(data);
};
